import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-[#f5efe1] border-y border-[#d3c8ac]" data-id="element-112">
      <div className="container mx-auto px-4 text-center" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-[0_16px_40px_-20px_rgba(31,50,39,0.35)] border border-[#e0d6bf]" data-id="element-114">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#eaf3ec] text-[#2f6b47] mb-6 border border-[#c6e0cf]" data-id="element-115">
            <ShieldCheck className="w-10 h-10" data-id="element-116" />
          </div>

          <h2 className="text-3xl font-black text-[#1e4230] mb-4 font-[Merriweather,_serif]" data-id="element-117">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-lg text-[#4a4133] mb-6" data-id="element-118">
            Abrís los tomos. Los usás. Si en 7 días no es lo que esperabas:
          </p>

          <div className="bg-[#1e4230] text-[#f5efe1] font-bold text-xl py-4 px-6 rounded-xl mb-6 border border-[#c8971b]/40" data-id="element-119">
            Devolución del 100% sin formularios, sin drama.
          </div>

          <p className="text-sm text-[#6f4e2e] font-medium uppercase tracking-wider" data-id="element-120">
            Tasa de devoluciones: menos del 1%.
          </p>
        </motion.div>
      </div>
    </section>;
}